export default {
    setManagerList(state, { data }) {
        state.managerList = data;
    }
};
